export default function Footer() {
  return (
    <footer className="py-12 px-6 lg:px-8 border-t border-white/10">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between mb-8">
          <div className="flex items-center space-x-3 mb-6 md:mb-0">
            <div className="w-12 h-12 bg-gradient-to-br from-[#0EA5E9] to-[#06B6D4] rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-xl">AI</span>
            </div>
            <div>
              <div className="text-white font-bold text-xl leading-tight">Daily Nest Group, LLC</div>
              <div className="text-gray-400 text-sm">AiConnect Product Division</div>
            </div>
          </div>

          <div className="flex items-center space-x-6">
            <a
              href="https://dailynestgroup.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-white transition-colors cursor-pointer"
            >
              <i className="ri-global-line text-2xl"></i>
            </a>
            <a
              href="https://go247ai.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-white transition-colors cursor-pointer"
            >
              <i className="ri-robot-line text-2xl"></i>
            </a>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8">
          <p className="text-center text-gray-500 text-xs mt-4">
            © 2025 Daily Nest Group, LLC. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
